import { InfoIcon } from '@ordr-as/icons'
import JsonHighlight from 'components/JsonHighlight'
import ReactTooltip from 'react-tooltip'
import { formatDate } from 'utils/dateUtils'
import { PaymentMethodDetailsDto } from '../../../generated-api'

type PaymentMethodDetailsProps = {
    paymentMethodDetails: PaymentMethodDetailsDto
}

const PaymentMethodDetails = (props: PaymentMethodDetailsProps) => {
    const { paymentMethodDetails } = props

    return (
        <div>
            <div className="space-y-3">
                <div>
                    <div className="text-xs text-grey-dark">Payment provider</div>
                    <div className="text-bold">{paymentMethodDetails.paymentProvider}</div>
                </div>
                <div>
                    <div className="text-xs text-grey-dark">Payment method</div>
                    <div className="text-bold">{paymentMethodDetails.paymentMethod}</div>
                </div>
                <div>
                    <div className="text-xs text-grey-dark">Payment method category</div>
                    <div className="text-bold">{paymentMethodDetails.paymentMethodCategory}</div>
                </div>
                <div>
                    <div className="text-xs text-grey-dark">Payout source</div>
                    <div className="text-bold">{paymentMethodDetails.payoutSource}</div>
                </div>

                <div>
                    <div className="text-xs text-grey-dark">Created</div>
                    <div className="text-bold">
                        By user {paymentMethodDetails.createdByUserEmail} at {formatDate(paymentMethodDetails.created)}
                    </div>
                </div>

                <div>
                    <div className="text-xs text-grey-dark">Updated</div>
                    <div className="text-bold">
                        By user {paymentMethodDetails.updatedByUserEmail} at {formatDate(paymentMethodDetails.updated)}
                    </div>
                </div>

                <div>
                    <div className="flex text-grey-dark">
                        <InfoIcon className="mr-1" data-tip data-for="visible-in-apps-tooltip" />

                        <ReactTooltip
                            id="visible-in-apps-tooltip"
                            arrowColor="transparent"
                            effect="solid"
                            padding="1px 4px"
                            className="text-bold !opacity-100"
                        >
                            If set to true:
                            <br />
                            The payment method will be visible when it is enabled for a given Favrit app
                            <br />
                            on a country or location level.
                            <br />
                            <br />
                            If set to false:
                            <br />
                            The payment method will NOT be visible in any Favrit apps, even when the
                            <br />
                            payment method is enabled for the given app on a country or location level.
                            <br />
                        </ReactTooltip>
                        <div className="text-xs">Visible in apps</div>
                    </div>
                    <div className="text-bold">{paymentMethodDetails._configuration.visibleInApps ? 'Yes' : 'No'}</div>
                </div>

                <div>
                    <div className="text-xs text-grey-dark">Payment method display label</div>
                    <div className="text-bold">
                        {paymentMethodDetails._configuration.overridableConfiguration.paymentMethodDisplayLabel}
                    </div>
                </div>

                <div>
                    <div className="text-xs text-grey-dark">Unintegrated fields schema</div>
                    <div className="text-bold">
                        {paymentMethodDetails._configuration.overridableConfiguration.unintegratedFieldsSchema ? (
                            <JsonHighlight
                                object={
                                    paymentMethodDetails._configuration.overridableConfiguration
                                        .unintegratedFieldsSchema
                                }
                            />
                        ) : (
                            'No unintegrated fields'
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PaymentMethodDetails
